import { TProps } from './types/TProps';
import { Wrapper } from './styles/Wrapper';
import { CloseIcon } from './icons/Close';
import { useModalContext } from '@providers/ModalProvider';

export const ModalWrapper = ({ width, overflow, children }: TProps) => {
  const { closeModal } = useModalContext();
  return (
    <Wrapper width={width} overflow={overflow}>
      <CloseIcon className="close-icon" onClick={closeModal} />
      {children}
    </Wrapper>
  );
};
